import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';

const AdminLayout = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // ブラウザの戻るボタン対策：管理者は管理者ページ外に戻れない
    const handlePopState = (event) => {
      const adminToken = localStorage.getItem('admin_token');
      const adminUser = localStorage.getItem('admin_user');
      const isIntegratedAdmin = user && user.user_type === 'admin';
      const isAdminLogin = (adminToken && adminUser) || isIntegratedAdmin;

      if (isAdminLogin) {
        const adminPaths = ['/admin/dashboard', '/admin/wallet', '/admin/wallet-management', '/admin/banners'];
        const isAdminPath = adminPaths.some(path => location.pathname.startsWith(path));
        
        if (!isAdminPath) {
          console.log('AdminLayout: Preventing navigation outside admin area');
          event.preventDefault();
          navigate('/admin/dashboard', { replace: true });
        }
      }
    };

    // ページリロード対策
    const handleBeforeUnload = (event) => {
      // 必要に応じてリロード時の確認ダイアログ
      // event.preventDefault();
      // event.returnValue = '';
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [user, location, navigate]);

  // ローディング中は読み込み画面を表示
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">認証確認中...</p>
        </div>
      </div>
    );
  }

  // 管理者認証チェック
  const adminToken = localStorage.getItem('admin_token');
  const adminUser = localStorage.getItem('admin_user');
  const isIntegratedAdmin = user && user.user_type === 'admin';
  const isAdminLogin = (adminToken && adminUser) || isIntegratedAdmin;

  // ここで守るのは純粋な運営者用ページのみ（求職者/事業者の管理ページは対象外）
  const pureAdminPaths = ['/admin/dashboard', '/admin/wallet', '/admin/wallet-management', '/admin/banners'];
  const isPureAdminPath = pureAdminPaths.some(path => location.pathname.startsWith(path));

  if (isPureAdminPath && !isAdminLogin) {
    console.log('AdminLayout: Not authenticated admin for pure admin path, redirecting to home');
    return <Navigate to="/" replace />;
  }

  // 管理者専用レイアウト（ナビゲーションバーやフッターなし）
  const onDashboard = location.pathname.startsWith('/admin/dashboard');

  return (
    <div className="admin-layout min-h-screen bg-gray-50">
      {/* Top bar with Back to Admin Dashboard (hidden on dashboard itself) */}
      {!onDashboard && (
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-12 flex items-center">
            <button
              onClick={() => navigate('/admin/dashboard')}
              className="mr-2 p-2 rounded hover:bg-gray-100 transition-colors clickable"
              title="ダッシュボードに戻る"
            >
              <ArrowLeftIcon className="w-5 h-5 text-gray-700" />
            </button>
            <span className="text-sm text-gray-600">運営ダッシュボードへ戻る</span>
          </div>
        </div>
      )}

      <div className="admin-content">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;